'use strict';

var _ = require('lodash');
var OfflineCalendarReviewTransformerFactory = function OfflineCalendarReviewTransformerFactory(DataTransformer, momentService) {
  function OfflineCalendarReviewTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'seasonality-analysis-chart-historical';
    this.targetType = ['seasonality-offline-calendar-review', 'seasonality-offline-calendar-review-show-up'];
    this.priority = 1;
  }
  OfflineCalendarReviewTransformer.prototype = Object.create(DataTransformer.prototype);
  OfflineCalendarReviewTransformer.constructor = OfflineCalendarReviewTransformer;
  OfflineCalendarReviewTransformer.prototype.canTransform = function (sourceType, targetType) {
    if (this.sourceType === sourceType && this.targetType.indexOf(targetType) > -1) {
      this.currentSourceType = sourceType;
      this.currentTargetType = targetType;
      return true;
    }
    return false;
  };
  OfflineCalendarReviewTransformer.prototype.isCacheable = function () {
    return false;
  };
  OfflineCalendarReviewTransformer.prototype.getCacheKey = function () {
    return this.currentSourceType + '-' + this.currentTargetType;
  };
  OfflineCalendarReviewTransformer.prototype.transform = function (data) {
    var results = [];
    for (var i = 0, length = data.domain.analysis.length; i < length; i++) {
      var calendar = data.domain.analysis[i];
      for (var j = 0, outputsLength = calendar.outputs.length; j < outputsLength; j++) {
        var output = calendar.outputs[j];
        for (var k = 0, weeklyDataPointsLength = output.weeklyDataPoints.length; k < weeklyDataPointsLength; k++) {
          var weeklyDataPoint = output.weeklyDataPoints[k];
          var override = _.filter(calendar.seasonalityOverrides, function (override) {
            return findOverrides(override, output, weeklyDataPoint);
          });
          var newEntry = {
            market: calendar.origin + '-' + calendar.destination,
            level: calendar.seasonalityLevel,
            metric: calendar.seasonalityVariable,
            classGroup: output.classGroup,
            spos: output.spos,
            cabin: output.cabin,
            weekOfYear: weeklyDataPoint.week,
            dowGroup: weeklyDataPoint.dowGroup,
            season: _.isEmpty(override) ? weeklyDataPoint.season : override[0].season
          };
          results.push(newEntry);
        }
      }
      for (var s = 0, specialEventsLength = calendar.specialEvents.length; s < specialEventsLength; s++) {
        var specialEvent = calendar.specialEvents[s];
        var newEventEntry = {
          startDate: momentService.of(specialEvent.startDepartureDate, momentService.FIELD.DEPARTURE_DATE),
          endDate: momentService.of(specialEvent.endDepartureDate, momentService.FIELD.DEPARTURE_DATE),
          season: specialEvent.eventName,
          market: specialEvent.market,
          level: calendar.seasonalityLevel,
          metric: calendar.seasonalityVariable,
          isSpecialEvent: true
        };
        results.push(newEventEntry);
      }
    }
    return results;
  };
  function findOverrides(override, output, weeklyDataPoint) {
    return (_.isNil(override.classGroup) && _.isNil(output.classGroup) || override.classGroup === output.classGroup) && (_.isNil(override.significantPOS) && _.isNil(output.spos) || override.significantPOS === output.spos) && override.dowGroup === weeklyDataPoint.dowGroup && override.weekNo === weeklyDataPoint.week;
  }
  return OfflineCalendarReviewTransformer;
};
OfflineCalendarReviewTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = OfflineCalendarReviewTransformerFactory;